<template>
  <div class="nav-mobile">
    <b-container>
      <upper-part />
      <lower-part />
    </b-container>
  </div>
</template>

<script>
import UpperPart from "./UpperPart";
import LowerPart from "./LowerPart";

export default {
  name: "NavMobile",
  components: { UpperPart, LowerPart },
};
</script>
